export default __webpack_public_path__ + "static/visual-noise-dont-8ccea41d91cce5a5f4bf34fe63950607b9caf86f035a52289cb59bec1ed0f483.png";